import React from "react";
import PropTypes from "prop-types";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Stack from "@mui/material/Stack";

/**
 * Toast — 畫面上方置中，由上往下疊。每則都有關閉鈕；不按的話由 Layout 計時自動收掉
 * （操作回饋 2.6 秒、推播通知 5 秒）。
 * 外觀是 MUI 的 filled Alert：成功 success、失敗 error。
 * 進出場用 Collapse：關閉時 Layout 先標 leaving，動畫收完才從清單移除。
 * role="status"／"alert"：讀螢幕會念出訊息，失敗的訊息會打斷目前朗讀。
 */
function Toasts({ toasts, onClose }) {
  if (!toasts.length) return null;
  return (
    <Stack
      sx={{
        position: "fixed",
        top: 16,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1400,
        width: "max-content",
        maxWidth: "calc(100vw - 32px)",
        alignItems: "center",
        pointerEvents: "none",
      }}
    >
      {toasts.map((t) => (
        <Collapse key={t.id} in={!t.leaving} appear timeout={200} sx={{ pointerEvents: "auto" }}>
          <Alert
            variant="filled"
            severity={t.tone === "error" ? "error" : "success"}
            role={t.tone === "error" ? "alert" : "status"}
            onClose={() => onClose(t.id)}
            closeText="關閉"
            sx={{ boxShadow: 6, mb: 1, alignItems: "center", minWidth: 280 }}
          >
            {t.msg}
          </Alert>
        </Collapse>
      ))}
    </Stack>
  );
}

Toasts.propTypes = { toasts: PropTypes.array, onClose: PropTypes.func };
Toasts.defaultProps = { toasts: [], onClose: () => {} };

export default Toasts;
